import { z } from 'zod';
import { capitalize } from '../../utils/capitalize.js';
import { optionalTrimmedNullableString, optionalUuidString, requiredUuidString, } from '../zod-helpers/index.js';
import { ADDRESS_CONSTRAINTS } from './constraints.js';
export const optionalStateIdSchema = optionalUuidString('Invalid state.')
    .nullish()
    .transform((value) => (value === '' ? null : value));
export const optionalCountryIdSchema = optionalUuidString('Invalid country.')
    .nullish()
    .transform((value) => (value === '' ? null : value));
const requiredAddressPart = (label, maxLength) => z.string().trim().min(1, `${label} is required.`).max(maxLength);
export function addressPartSchemas({ requireFullAddress = false, } = {}) {
    if (!requireFullAddress) {
        return {
            city: optionalTrimmedNullableString(ADDRESS_CONSTRAINTS.city.maxLength),
            stateId: optionalStateIdSchema,
            countryId: optionalCountryIdSchema,
            zip: optionalTrimmedNullableString(ADDRESS_CONSTRAINTS.zip.maxLength),
        };
    }
    return {
        city: requiredAddressPart(ADDRESS_CONSTRAINTS.city.label, ADDRESS_CONSTRAINTS.city.maxLength),
        stateId: requiredUuidString('State is required.', 'Invalid state.'),
        countryId: requiredUuidString('Country is required.', 'Invalid country.'),
        zip: requiredAddressPart(ADDRESS_CONSTRAINTS.zip.label, ADDRESS_CONSTRAINTS.zip.maxLength),
    };
}
export const nameSchema = z
    .string()
    .trim()
    .min(1, `${ADDRESS_CONSTRAINTS.name.label} is required.`)
    .max(ADDRESS_CONSTRAINTS.name.maxLength);
export const addressNameSchema = z
    .string()
    .trim()
    .min(1, `${capitalize(ADDRESS_CONSTRAINTS.addressName.label.toLowerCase())} is required.`)
    .max(ADDRESS_CONSTRAINTS.addressName.maxLength);
export const addressSchema = z
    .string()
    .trim()
    .min(1, `${capitalize(ADDRESS_CONSTRAINTS.address.label.toLowerCase())} is required.`)
    .max(ADDRESS_CONSTRAINTS.address.maxLength);
export function buildAddressInputSchemas(allowedTypes, invalidTypeMessage = 'Invalid address type.', strictness = {}) {
    const typeIdSchema = z.enum(allowedTypes, invalidTypeMessage);
    const createAddressInputSchema = z.object({
        name: nameSchema,
        addressName: addressNameSchema,
        typeId: typeIdSchema,
        address: addressSchema,
        ...addressPartSchemas(strictness),
        defaultFlag: z.boolean().optional(),
    });
    return {
        createAddressInputSchema,
        typeIdSchema,
    };
}
//# sourceMappingURL=create-input.js.map